const doc = [({"en":({"adminConstantHotelLinkType":({"allLink":"Show all", "engineLink":"Only on the Tabichat Engine", "noneLink":"Hidden"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;